/**
 * The floating feedback button, bottom-right on every screen.
 *
 * One button, everywhere, for everybody: a client in the portal, an officer at
 * the desk, somebody verifying a certificate with no account at all. It sits
 * in the same corner on every page so that "where do I say something" has one
 * answer, and it is a pill rather than a bare circle so the answer is written
 * on it the moment a pointer comes near. The toasts share the corner and start
 * above it, so a notice never lands on the button.
 *
 * Deliberately not on the feedback page itself (the page is the destination),
 * and not in print, where a floating button over a certificate is a defect.
 */

import { MessageSquareHeart } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

import { FEEDBACK_PATH } from "@/components/FeedbackInvite";
import { toTitleCase } from "@/lib/format";

const LABEL = "How did we do?";

export function FeedbackFab() {
  const { pathname } = useLocation();
  if (pathname === FEEDBACK_PATH) return null;

  return (
    <Link
      to={FEEDBACK_PATH}
      aria-label="Tell us how it went. Opens the feedback page; no sign-in needed."
      title={LABEL}
      className="feedback-fab group print:hidden"
    >
      {/* A ring that breathes a few times after the page loads, then settles.
          Enough to be noticed once; not enough to be noticed all day. */}
      <span aria-hidden="true" className="feedback-fab-ring motion-reduce:hidden" />
      <span className="feedback-fab-icon">
        <MessageSquareHeart size={22} />
      </span>
      <span className="feedback-fab-label">{toTitleCase(LABEL)}</span>
    </Link>
  );
}
